import {FormatChars} from './types'

export const DEFAULT_FORMAT_CHARS: FormatChars = {
  '+': '[+]',
  '#': '[0-9]',
}
